'use strict';

/**
 * Module definition file
 *
 * All services, controllers, and directives are registered with angular here
 * 
 * Bower dependencies should NOT be require here. They should be required in tests/lib.js.
 */

require('./dropdownHeader');
require('./dropdownContent');

var dropdown = angular.module('saturn.dropdown', [
  'saturn.dropdown.content',
  'saturn.dropdown.header',
]);

var DropdownController = require('./DropdownController');
var DropdownDirective = require('./DropdownDirective');
var DropdownService = require('./DropdownService');

// ## Services

dropdown.service('DropdownService', [
  '$document',
  '$rootScope',
  DropdownService
]);

// ## Controllers

dropdown.controller('DropdownController', [
  '$log',
  '$scope',
  'DropdownService',
  DropdownController
]);

// ## Directives

dropdown.directive('sbDropdown', [
  DropdownDirective
]);

// ## Template Module
require('./templates.js');



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dropdown/src/index.js